/* eslint-disable */
import Vue from 'vue'
import Acl from './acl'
import Drag from './drag'
import Sticky from './sticky'
import Scroll from './scroll'

Vue.use(Drag)
Vue.use(Sticky)
Vue.use(Scroll)
Vue.use(Acl)


// WEBPACK FOOTER //
// ./src/_fdp/core/directive/index.js